var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio',{attrs:{"value":_vm.value,"label":"13"}},[_vm._v(" CC ")]),_c('el-radio',{attrs:{"value":_vm.value,"label":"31"}},[_vm._v(" NIT ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }